import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import { FaQuestionCircle } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import DeviceIcon from '../../components/UI/DeviceIcon/DeviceIcon';
import Spinner from '../../components/UI/Spinner/Spinner';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import classes from './BackHaul.css';




export class BackHaul extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upArrow: true,
    };
    this.resetUpArrow = this.resetUpArrow.bind(this);
    this.getPodDetails = this.getPodDetails.bind(this);
  }

  openHandler() {
    this.setState({
      upArrow: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrow: false,
    });
  }
  resetUpArrow() {
    this.setState({
      upArrow: false,
    });
  }
  DeviceIcon = ({id}) =>{
    console.log("what is id", id);
  const isMacAddress = id.length === 12;
 

  return (
    <>
    {isMacAddress   ? <router /> :  <DeviceIcon /> 
    }
    </>
  )
 }
  getPodDetails(val, podValues) {
    // console.log( "what is this",val)
    podValues['connectionState'] = val.connectionState.includes('connected')
      ? 'Connected'
      : val.connectionState;
    if (val.nickname) {
      podValues['podName'] = val.nickname;
    } else {
      podValues['podName'] = val.defaultName;
    }

    podValues['podId'] = val.id;
    
    if (val.leafToRoot && val.leafToRoot[0] && val.leafToRoot[0].id) {
      podValues['parentPodId'] = val.leafToRoot[0].id;
    }

    if (val.backHaul && val.backHaul.metadata) {
      if (
        val.backHaul.metadata.freqBand &&
        (val.backHaul.metadata.freqBand.includes('5G') ||
          val.backHaul.metadata.freqBand.includes('5g'))
      ) {
        podValues['freqBand'] = '5GHz';
      } else if (
        val.backHaul.metadata.freqBand &&
        (val.backHaul.metadata.freqBand.includes('2.4G') ||
          val.backHaul.metadata.freqBand.includes('2.4g'))
      ) {
        podValues['freqBand'] = '2.4GHz';
      } else if (
        val.backHaul.metadata.freqBand &&
        (val.backHaul.metadata.freqBand.includes('6G') ||
          val.backHaul.metadata.freqBand.includes('6g'))
      ) {
        podValues['freqBand'] = '6GHz';
      }
       else {
        podValues['freqBand'] = 'N/A';
      }
      if (val.backHaul.metadata.channel) {
        podValues['channel'] = val.backHaul.metadata.channel;
      } else {
        podValues['channel'] = 'N/A';
      }
      podValues['backhaulType'] = val.backhaulType;
    } else {
      podValues['freqBand'] = 'N/A';
      podValues['channel'] = 'N/A';
      podValues['backhaulType'] = val.backhaulType;
    }

    if (val.health && val.health.status) {
      if (val.health.status === 'excellent') {
        podValues['strength'] = 'Excellent';
        podValues['strengthColor'] = { textAlign: 'center', color: 'green' };
      } else if (val.health.status === 'good') {
        podValues['strength'] = 'Good';
        podValues['strengthColor'] = { textAlign: 'center', color: 'green' };
      } else if (val.health.status === 'poor') {
        podValues['strength'] = 'Poor';
        podValues['strengthColor'] = { textAlign: 'center', color: 'red' };
      } else if (val.health.status === 'calculating') {
        podValues['strength'] = 'Calculating';
        podValues['strengthColor'] = { textAlign: 'center', color: '#D6922B' };
      } else if (val.health.status === 'fair') {
        podValues['strength'] = 'Fair';
        podValues['strengthColor'] = { textAlign: 'center', color: 'red' };
      }
    } else {
      podValues['strength'] = 'N/A';
      podValues['strengthColor'] = { textAlign: 'center' };
    }

    return podValues;
  }

  render() {
    let backHaulDevice = {
      deviceIconReference: 'BACKHAULICON',
    };
     let extenderDevice = {
      deviceIconReference: 'ROUTERICON',
     };
     
    let routerDevice = {
      deviceIconReference: 'ROUTERICON',
    };
    let PodDevice = {
      deviceIconReference: 'DEVICEICON',
    };
   
    let backHaulData = [];
    let backHaulPreData = [];
    let podsData;
    let subPodsData;
    let routerData;
    let val;
    // let ExtenderDevice;

    if (this.props.equipment.loading || !this.props.equipment.loaded) {
      return <Spinner />;
    }
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrow) {
      arrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    }
    let deviceIcon = true;
    if (
      this.props.equipment.selectedEquipment.podConnectionState === 'connected'
    ) {
      if (
        this.props.equipment.loaded &&
        this.props.equipment &&
        this.props.equipment.realEquipment &&
        this.props.equipment.realEquipment.claimedPods &&
        this.props.equipment.realEquipment.claimedPods.length
      ) {
        this.props.equipment.realEquipment.claimedPods.forEach((val) => {
          console.log("val.id", val.id.length === 12 ? "Extender" : "pod")
          if(val.id.length  === 12){
            backHaulDevice = {
            deviceIconReference: 'ROUTERICON',
          };
          } else if (val.id.length  === 15)
          {
            extenderDevice = {
              deviceIconReference: 'BACKHAULICON',
            };
          } 
        //   if(val.id.length === 15) {
        //     backHaulDevice = {
        //       deviceIconReference: 'BACKHAULICON',
        //   };
        // }
          if (val.connectionState === 'connected') {
            let podValues = {};
            if (
              this.props.wan &&
              this.props.wan.loaded &&
              this.props.wan.realWan
            ) {
              podValues['routerName'] = 'Router';
            } else {
              podValues['routerName'] = 'N/A';
            }
            podValues = this.getPodDetails(val, podValues);

            backHaulPreData.push(podValues);
          }
        });
      
        backHaulPreData.forEach((value, key) => {
          if (this.props.equipment.selectedEquipment.podId === value.podId) {
            if (this.props.equipment.selectedEquipment.podId === value.podId) {
              backHaulPreData.forEach((v, k) => {
                if (value.parentPodId === v.podId) {
                  backHaulData.push(v);
                }
              });
            }
            backHaulData.push(value);
          }
        });

        routerData = backHaulData[0] && (
          [<Box>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <DeviceIcon originalDevice={routerDevice} size={60} />
            </div>
            <div
              className={classes.showDesktop}
              style={{ textAlign: 'center' }}
            >
              {backHaulData[0].routerName}
            </div>
          </Box>]
        );

        podsData = backHaulData.map((key, value) => {
          let highlightPod = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          };
          let bgColor = { background: 'none' };
          if (
            backHaulData[value].podId ===
            this.props.equipment.selectedEquipment.podId
          ) {
            highlightPod = {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            };
            bgColor = { background: '#eee' };
          }
          let freqBandvalue, questionMark;
          if (backHaulData[value]['backhaulType'] === 'ethernet') {
            freqBandvalue = (
              <p style={{ textAlign: 'center' }}>Connection: Ethernet</p>
            );
            questionMark = (
              <span className={classes.QuestionCircle}>
                <FaQuestionCircle
                  className={classes.QuestionCircleImage}
                ></FaQuestionCircle>
                <span className={classes.QuestionCircleToolTip}>
                  undetermined backhaul
                </span>
              </span>
            );
          } else if (
            backHaulData[value]['freqBand'] === 'N/A' &&
            backHaulData[value]['channel'] === 'N/A'
          ) {
            freqBandvalue = (
              <p style={{ textAlign: 'center' }}>Connection: N/A</p>
            );
          } else {
            freqBandvalue = (
              <p id = 'PodConnectionFq' style={{ textAlign: 'center' }}>
                Connection: {backHaulData[value]['freqBand']}/
                {backHaulData[value]['channel']}
              </p>
            );
          }
          let signalValue;
          if (backHaulData[value]['backhaulType'] !== 'ethernet') {
            signalValue = (
              <p id = 'PodSignal' style={{ textAlign: 'center' }}>
                Signal:{' '}
                <span style={backHaulData[value]['strengthColor']}>
                  {' '}
                  {backHaulData[value].strength}
                </span>
              </p>
            );
          } else {
            signalValue = (
              <p style={{ textAlign: 'center' }}>
                Signal:{' '}
                <span style={backHaulData[value]['strengthColor']}>
                  {' '}
                  {backHaulData[value].connectionState}
                </span>
              </p>
            );
          }

          return (
            <Box>
              <div style={{ marginLeft: '10px' }}>
                {freqBandvalue}
                <hr className={classes.StrippedLineSeparator} />
                {signalValue}
              </div>

              <div className={classes.InfoItem} style={{ height: '100px' }}>
                <div style={highlightPod}>
                  <div style={bgColor}>
                    <DeviceIcon originalDevice={backHaulData[value].podId.length === 12 ? backHaulDevice : extenderDevice} size={60} />
                  </div>
                </div>
            
                <div className={classes.SmallInfoRow}>
                  <div
                    className={classes.showDesktop}
                    style={{ textAlign: 'center', display: 'inline-grid' }}
                  >
                    <span className={classes.BackHaulWordBreak} style={{ whiteSpace: 'break-spaces' }}>
                      {backHaulData[value].podName}{' '}
                    </span>
                    {questionMark}
                  </div>
                </div>
              </div>
            </Box>
          );
        });
      }
    } else {
      if (!(routerData && routerData.length > 0) || routerData === undefined) {
        routerData = 'Extender is disconnected. No backhaul available.';
        deviceIcon = false;
      }
    } 
    let infoRow;
    if (
      (this.props.wan.checkingWan ||
        (this.props.wan.podTimer &&
          this.props.wan.rebootPodId ===
          this.props.equipment.selectedEquipment.podId)) &&
      this.props.wan.timerStart
    ) {
      infoRow = (
        <Box>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'left',
              padding: 20,
            }}
          >
            BackHaul is not available while the Extender is rebooting.
          </div>
        </Box>
      );
    } else if (deviceIcon) {
      infoRow = (
        <Box>
          <div></div>
          <div className={classes.backHaulWrapper}>
            <div className={classes.InfoRow}>
              <div className={classes.InfoItem} style={{ height: '100px' }}>
                {routerData}
              </div>
              {podsData}
            </div>
          </div>
        </Box>
      );
    } else {
      infoRow = (
        <Box>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'left',
              padding: 20,
            }}
          >
            {routerData}
          </div>
        </Box>
      );
    }

    return (
      <Box>
        <div className={classes.BackHaul}>
          <Collapsible
            open={true}
            overflowWhenOpen={'scroll'}
            transitionTime={100}
            onOpening={() => {
              this.openHandler();
            }}
            onClosing={() => {
              this.closeHandler();
            }}
            trigger={
              <Box>
                <div className={classes.TitleArea}>
                  <h3 style={{ paddingRight: 20 }}>BackHaul</h3>
                  <button
                    className={classes.OpenCloseButton}
                    style={{ float: 'right' }}
                    aria-label="open arrow"
                  >
                    {arrow}
                  </button>
                </div>
                <div className={classes.HorizontalSeparator} />
              </Box>
            }
          >
            {infoRow}
          </Collapsible>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(BackHaul, api));
